import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";

const SelectDescriptive = ({
  name,
  value,
  onChange,
  options = [],
  grouped = false,
  placeholder = "Selecciona una opción",
  className = ""
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const [showHiddenOptions, setShowHiddenOptions] = useState(false);
  const ref = useRef(null);
  const tooltipTimeout = useRef(null);

  useEffect(() => {

    const onClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
        clearTooltip();
      }
    }

    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);

  }, []);

  const selectedOption = grouped 
    ? options.flatMap(group => group.options).find(opt => opt.value == value) 
    : options.find(opt => opt.value == value);

  const onSelect = (option) => {
    onChange({ target: { name, value: option.value } });
    setIsOpen(false);
    clearTooltip();
  }

  const onMouseEnter = (opt, event) => {

    if(!opt.description) return;

    const rect = event.currentTarget.getBoundingClientRect();
    tooltipTimeout.current = setTimeout(() => {
      setHoveredOption(opt);
      setTooltipPosition({
        top: rect.top,
        left: rect.right + 10
      });
      setShowTooltip(true);
    }, 1000);

  }

  const onMouseLeave = () => {
    clearTooltip();
  }

  const clearTooltip = () => {
    clearTimeout(tooltipTimeout.current);
    setHoveredOption(null);
    setShowTooltip(false);
  }

  const hasHiddenOptions = options.some(opt => opt.hidden);

  return (
    <div className="position-relative" ref={ref}>
      
      <div className="dropdown position-relative" ref={ref}>
        <button
          type="button"
          className={`form-control text-start ${className}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div className="d-flex flex-column align-items-start">
            <span>{selectedOption?.label || placeholder}</span>
          </div>
        </button>

        {isOpen && (
          <div
            className="border bg-white card-body show w-100 shadow-sm p-0 position-relative"
            style={{ maxHeight: 250, overflowY: 'auto', zIndex: 2 }}
          >

            {grouped && options.map((group, idx) => (
              (!group.options.every(opt => opt.hidden) || showHiddenOptions) &&
              <div key={`group-${idx}`}>
                <div className="text-dark mt-2 mb-1 px-3 h6">
                  {group.label}
                </div>
                {group.options.map((opt, index) => (
                  (!opt.hidden || showHiddenOptions) &&
                  <div
                    key={`opt-${opt.value}`}
                    className={`dropdown-item d-flex flex-column position-relative ${opt.value == value ? 'active bg-primary text-white' : ''}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelect(opt)}
                    onMouseEnter={(e) => onMouseEnter(opt, e)}
                    onMouseLeave={onMouseLeave}
                  >
                    <span>{opt.label}</span>
                  </div>
                ))}
              </div>
            ))}

            {!grouped && options.map((opt, index) => (
              (!opt.hidden || showHiddenOptions) && 
              <div
                key={`opt-${opt.value}`}
                className={`dropdown-item d-flex flex-column position-relative ${opt.value == value ? 'active bg-primary text-white' : ''}`}
                style={{ cursor: "pointer" }}
                onClick={() => onSelect(opt)}
                onMouseEnter={(e) => onMouseEnter(opt, e)}
                onMouseLeave={onMouseLeave}
              >
                <span>{opt.label}</span>
              </div>
            ))}

            {hasHiddenOptions && (
              <div className="text-center">
                <button
                  type="button"
                  className={`dropdown-item d-flex flex-column position-relative`}
                  onClick={() => setShowHiddenOptions(!showHiddenOptions)}
                >
                  {showHiddenOptions ? "Ocultar" : "Mostrar"} opciones
                </button>
              </div>
            )}

          </div>
        )}
        
      </div>

      {showTooltip && hoveredOption && ReactDOM.createPortal(
        <div
          className="position-absolute bg-light border rounded shadow-sm p-2"
          style={{
            top: `${tooltipPosition.top}px`,
            left: `${tooltipPosition.left}px`,
            zIndex: 9999,
            position: "absolute",
            width: "250px"
          }}
        >
          <div className="text-dark">
            {hoveredOption.description}
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default SelectDescriptive;